var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sub-menu", style: _vm.getSubMenuStyle }, [
    _c("div", { staticClass: "sub-menu__header" }, [
      _c("h1", { staticClass: "sub-menu__header-title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.getItemTitle(_vm.getActiveSubMenu)) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sub-menu__header-back",
          class: { "sub-menu__header-back--active": _vm.isBackFocused }
        },
        [
          _c(
            "Icon",
            { attrs: { color: "#f1f1f1", height: 32, width: 32 } },
            [_c("ArrowLeft")],
            1
          ),
          _vm._v("\n      " + _vm._s(_vm.getBack) + "\n    ")
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sub-menu__content" }, [
      _c(
        "div",
        { staticClass: "sub-menu__preview", style: _vm.getVodPreviewStyle },
        [
          _vm.getPreviewSource
            ? _c("div", { staticClass: "sub-menu__preview-thumbnail" }, [
                _c("img", {
                  staticClass: "preview-image",
                  attrs: { src: _vm.getPreviewSource, alt: "" }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "sub-menu__preview-description",
              style: _vm.getVodListStyle
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getItemDescription(_vm.getActiveItem)) +
                  "\n      "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "listWrapper",
          staticClass: "sub-menu__list",
          style: [_vm.getStyleSheetOffset, _vm.getVodListStyle]
        },
        _vm._l(_vm.getActiveSubMenuItems, function(el, index) {
          return _c(
            "li",
            {
              key: "event-" + index,
              ref: "listElements",
              refInFor: true,
              staticClass: "sub-menu__list-element",
              class: {
                "--active":
                  !_vm.isBackFocused &&
                  index === _vm.getActiveSubMenuElementIndex
              },
              style: _vm.getVodListItemStyle(index),
              on: {
                click: function() {
                  return _vm.handleItemClickSelect(index)
                }
              }
            },
            [
              el.icon
                ? _c("div", { staticClass: "sub-menu__list-element-icon" }, [
                    _c("img", { attrs: { src: el.icon, alt: el.name } })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "sub-menu__list-element-name" }, [
                _vm._v(_vm._s(_vm.getItemTitle(el)))
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a57470e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a57470e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SubVodMenu.vue
// module id = null
// module chunks = 